import { Language } from "~types/types";
import { Locale } from "~types/wardenclyffe";

export function isValidLocale(str: string): str is Locale {
    return Object.values(Locale).includes(str as unknown as Locale);
}
export { Locale };

export enum TRANSLATION_LANGUAGES {
    EN = "EN",
    JA = "JA",
    FR = "FR",
    DE = "DE",
    ES = "ES",
    PT = "PT",
    IT = "IT",
    ZT = "ZT",
    KO = "KO",
    ZH = "ZH",
}

export const LANGUAGE_LOCALE_MAP = {
    en: "EN",
    ja: "JA",
    fr: "FR",
    de: "DE",
    es: "ES",
    pt: "PT",
    it: "IT",
    zt: "ZT",
    ko: "KO",
    zh: "ZH",
} as const;

export const LANGUAGE_NAMES: Record<Language, string> = {
    en: "English",
    ja: "Japanese",
    de: "German",
    es: "Spanish",
    pt: "Portuguese",
};

export const HUMAN_FRIENDLY_LANGUAGE_NAME = {
    [TRANSLATION_LANGUAGES.EN]: "English",
    [TRANSLATION_LANGUAGES.JA]: "Japanese",
    [TRANSLATION_LANGUAGES.FR]: "French",
    [TRANSLATION_LANGUAGES.DE]: "German",
    [TRANSLATION_LANGUAGES.ES]: "Spanish",
    [TRANSLATION_LANGUAGES.PT]: "Portuguese",
    [TRANSLATION_LANGUAGES.IT]: "Italian",
    [TRANSLATION_LANGUAGES.ZT]: "Traditional Chinese",
    [TRANSLATION_LANGUAGES.KO]: "Korean",
    [TRANSLATION_LANGUAGES.ZH]: "Simplified Chinese",
};

export const LANGUAGE_NUMERAL_MAPPING = {
    [TRANSLATION_LANGUAGES.EN]: 1,
    [TRANSLATION_LANGUAGES.JA]: 2,
    [TRANSLATION_LANGUAGES.FR]: 3,
    [TRANSLATION_LANGUAGES.DE]: 4,
    [TRANSLATION_LANGUAGES.ES]: 5,
    [TRANSLATION_LANGUAGES.PT]: 6,
    [TRANSLATION_LANGUAGES.IT]: 7,
    [TRANSLATION_LANGUAGES.ZT]: 8,
    [TRANSLATION_LANGUAGES.KO]: 9,
    [TRANSLATION_LANGUAGES.ZH]: 10,
};

interface LanguageOption {
    value: string;
    displayValue: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
    {
        value: "EN",
        displayValue: "English",
    },
    {
        value: "FR",
        displayValue: "Français",
    },
    {
        value: "DE",
        displayValue: "Deutsch",
    },
    {
        value: "ES",
        displayValue: "Español",
    },
    {
        value: "PT",
        displayValue: "Português",
    },
    {
        value: "IT",
        displayValue: "Italiano",
    },
    {
        value: "JA",
        displayValue: "日本語",
    },
    {
        value: "KO",
        displayValue: "한국어",
    },
    {
        value: "ZH",
        displayValue: "简体中文",
    },
    {
        value: "ZT",
        displayValue: "繁體中文",
    },
];
